const INTERACTIVE_SELECTOR = 'a, button, input, textarea, select, label, summary, [role="button"]';

function openDataUrlInNewTab(event) {
  if (event.defaultPrevented || event.button !== 0) {
    return;
  }

  const dataUrlElement = event.target?.closest?.('[data-url]');
  if (!dataUrlElement) {
    return;
  }

  const nestedInteractive = event.target.closest(INTERACTIVE_SELECTOR);
  if (nestedInteractive && nestedInteractive !== dataUrlElement) {
    return;
  }

  const url = dataUrlElement.getAttribute('data-url');
  if (!url) {
    return;
  }

  event.preventDefault();
  window.open(url.replace('~', ''), '_blank', 'noopener,noreferrer');
}

export function initDataUrlLinks() {
  document.addEventListener('click', openDataUrlInNewTab);
}
